//NEW STYPEPARAMS METHOD
var ARROWS_CONTAINER_STYLE_TYPE = {
    NONE: 'NONE',
    SHADOW: 'SHADOW',
    BOX: 'BOX',
};
export default ARROWS_CONTAINER_STYLE_TYPE;
//# sourceMappingURL=layoutParams_navigationArrows_container_type.js.map